import React, {useContext, useEffect, useReducer, useState} from 'react';
import axios from 'axios';
import classes from './ProductDetailPage.module.scss';
import {HomeBreadcrumb} from "../../../components/UI/HomeButton";
import ContactUs from "../../../components/ContactUs";
import ProductInfo from "./TabProductDetail/ProductInfo";
import {Helmet} from "react-helmet";
import RelatedInfo from "./TabProductDetail/RelatedInfo";
import ReactGa from "react-ga";
import {gaTracker} from "../../../helper/Helper";
import {LoadingSimple} from "../../../components/UI/LoadingBar";
import {goBackBreadcrumb} from "../../../utils/Utils";
import {FETCH_INIT_DATA, FETCH_RELATED_MENU_IDEAS, IS_LOADING, LANG_EN} from "../../../constants";
import {FormattedMessage} from "react-intl";
import {Context} from "../../../context/Wrapper";


//add by hendra on 13 oct 2020 06.00 pm
const [paramCategory, paramAction] = ['ProductLoad', 'View Product Detail'];

const initialState = {
    isLoading: false
    , isLoadingMenuIdeas: false
    , main_image: null
    , product: []
    , categories: []
    , product_images: []
    , product_variants: []
    , product_certificates: []
    , related_menu_ideas: []
}

const reducer = (state, action) => {
    switch (action.type) {
        case FETCH_INIT_DATA:
            return {
                ...state,
                product: action.product
                , main_image: action.mainImage
                , categories: action.categories
                , product_images: action.productImages
                , product_variants: action.productVariants
                , product_certificates: action.productCertificates
                // , related_menu_ideas: action.relatedMenuIdeas
                , isLoading: action.isLoading
            }
        case FETCH_RELATED_MENU_IDEAS:
            return {
                ...state,
                related_menu_ideas: action.payload,
                isLoadingMenuIdeas: action.isLoadMenuIdeas
            }
        case 'LOAD_MENU_IDEAS':
            return {
                ...state,
                isLoadingMenuIdeas: action.payload
            }
        case 'MAIN_IMAGE':
            return {
                ...state,
                main_image: action.payload
            }
        case IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            }
        default:
            return state
    }
}

const ProductDetailPageHook = (props) => {
    const context = useContext(Context)

    const [initEffect, setInitEffect] = useState(null);
    const [switchTab, setSwitchTab] = useState(1);
    const [selectedSize, setSelectedSize] = useState(undefined);
    const [state, dispatch] = useReducer(reducer, initialState)

    useEffect(() => {
        //==========================================
        // console.log('useEffect 1');
        //==========================================

        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        const loadDocumentTitle = () => {
            document.title =
                localStorage.getItem('selected_product_name')
                && localStorage.getItem('selected_product_name') !== null ?
                    `${localStorage.getItem('selected_product_name')}${(" | Japfa Food")}`
                    : 'Detail Product | Japfa Food | Indonesia | Food Supplier'
        }
        window.scrollTo(0, 0);

        const ourRequest = axios.CancelToken.source() // <-- 1st step
        const fetchData = async () => {

            dispatch({type: IS_LOADING, payload: true})
            const header = {headers: {'language': context.locale}};
            /*PRODUCT ID SLUG*/
            const paramSlugId = props.match.params.id;
            const firstThumbnail = [{image_original: null}];
            const productResponse = await axios.get('product/' + paramSlugId, header, {cancelToken: ourRequest.token});
            const productFetched = productResponse.data;
            firstThumbnail[0].image_original = productResponse.data.image_original;
            gaTracker(paramCategory, paramAction, productFetched.name + ' | ' + productFetched.product_brand_name)

            const product_images = await axios.get('product_images/' + productFetched.product_cd, header, {cancelToken: ourRequest.token});
            const product_variants = await axios.get('product_variants/' + productFetched.product_cd, header, {cancelToken: ourRequest.token});
            const product_certificates = await axios.get('product_certificates/' + productFetched.product_cd, header, {cancelToken: ourRequest.token});

            dispatch({
                type: FETCH_INIT_DATA
                , product: productFetched
                , mainImage: productFetched.image_original
                , productImages: product_images.data.product_images
                , productVariants: product_variants.data.product_variants
                , productCertificates: product_certificates.data.product_certificates
                // , relatedMenuIdeas: related_menu_ideas.data.related_menu_ideas
                , isLoading: false
            })

            // dispatch({type: IS_LOADING, payload: false})
        }
        try {
            fetchData();
            loadDocumentTitle();
            setInitEffect(null)
        } catch (e) {
            if (e.response.status === 404) {
                this.props.history.replace("/page-not-found")
            }
        }

        //hooks cleanup
        return () => {
            ourRequest.cancel() // <-- 3rd step
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.pathname, props.match.params.id, context.locale]);

    useEffect(() => {
        //============================================================
        // console.log('useEffect 2');
        //============================================================
        const ourRequest = axios.CancelToken.source() // <-- 1st step
        const fetchData = async () => {
            dispatch({type: 'LOAD_MENU_IDEAS', payload: true})

            const ourRequest = axios.CancelToken.source() // <-- 1st step
            const header = {headers: {'language': context.locale}};
            const related_menu_ideas = await axios.get('related_menu_ideas/' + state.product.product_cd, header, {cancelToken: ourRequest.token})
            dispatch({
                type: FETCH_RELATED_MENU_IDEAS
                , payload: related_menu_ideas.data.related_menu_ideas.length > 0 ? related_menu_ideas.data.related_menu_ideas : [{id: null}]
                , isLoadingMenuIdeas: false
            })

        }
        try {
            if (initEffect !== null) {
                fetchData();
            } else {
                return;
            }
        } catch (e) {
            setInitEffect(null)
        }
        //hooks cleanup
        return () => {
            ourRequest.cancel() // <-- 3rd step
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [switchTab, context.locale]);

    const setMainImage = (path) => {
        dispatch({type: 'MAIN_IMAGE', payload: path})
    }

    const selectSizeHandler = (event) => {
        if (+event.target.value !== 0) {
            const selectedValue = {
                ...state.product_variants.find(x => {
                    return x.product_variant_cd === event.target.value
                })
            };
            setSelectedSize(selectedValue.size + ' ' + selectedValue.product_unit.toLocaleString())
        } else {
            setSelectedSize(undefined)
        }
    }

    const goSomewhere = (isOnlyBackToCategory, productSelected) => {
        goBackBreadcrumb(props, isOnlyBackToCategory, productSelected)
    }

    // let paramProductId = +props.match.params.id;
    let breads;
    let thumbnails;
    let productInfo;
    let stringBadge;
    let tempMetaDesc;
    let metaDesc;

    if (state.product) {

        const productSelected = state.product;
        const productImages = state.product_images ? state.product_images : [];
        breads = (
            <div className={classes.Breadcrumb_row}>
                <HomeBreadcrumb/>
                <div className={classes.Breadcrumb_divided}>/</div>
                <div onClick={() => goSomewhere(true, productSelected)}>{productSelected.product_category_name}</div>
                <div className={classes.Breadcrumb_divided}>/</div>
                <div onClick={() => goSomewhere(false, productSelected)}>{productSelected.product_sub_category_name}</div>
                <div className={classes.Breadcrumb_divided}>/</div>
                <div>{productSelected.name}</div>
            </div>
        );

        tempMetaDesc = productSelected.description !== undefined ? productSelected.description.replace(/(<([^>]+)>)/ig, "") : '';
        metaDesc = tempMetaDesc.length > 150 ? tempMetaDesc.substr(0, 150).trim() : tempMetaDesc.trim();

        if (+productSelected.is_new_product === 1) {
            stringBadge = <div key={productSelected.id} className={["jbfs-badge-new", classes.Featured_badge].join(' ')}><FormattedMessage id={"global.product.badge.new"} defaultMessage={"NEW"}/></div>
        } else if (+productSelected.is_fav_product === 1) {
            stringBadge = <div key={productSelected.id} className={["jbfs-badge-fav", classes.Featured_badge].join(' ')}><FormattedMessage id={"global.product.badge.fav"} defaultMessage={"FAV"}/></div>
        }

        thumbnails = productImages.map((prodImg, index) => {
            return (
                <div key={index}
                     className={classes.Thumbnail_bgImageThumbnail}
                     onClick={() => setMainImage(prodImg.image_original)}
                     style={{backgroundImage: `url(${prodImg.image_original})`}}
                />
            )
        });


        let messageSize = '';
        if (selectedSize) {
            messageSize = ', Size: ' + selectedSize;
        }

        const product = state.product;
        productInfo = (
            <div key={product.id} className={classes.Right_content}>
                {state.isLoading ? (<LoadingSimple position={'left'}/>) : <h2 className={["jbfs-title-case", classes.Info_title].join(' ')}>{product.name}</h2>}
                <div className={classes.InfoBrand_wrapper}>
                    {product.product_brand_image_icon ?
                        <img src={product.product_brand_image_icon} alt={'text'}/> : ''}
                    <div className={["jbfs-title-case"].join(' ')}>{product.product_brand_name}</div>
                </div>
                <div className={classes.Info_size}>
                    <div>
                        <label><FormattedMessage id={"proddetail.size"} defaultMessage={"SIZE"}/></label>
                    </div>
                    <select className={'jbfs-select'}
                            onChange={(event) => selectSizeHandler(event)}>
                        {context && context.locale === LANG_EN ?
                            <option value={0}>{'--Choose Size--'}</option> :
                            <option value={0}>{'--Pilih Ukuran--'}</option>}
                        {state.product_variants && state.product_variants.map((option, index) => {
                            return (
                                <option key={index}
                                        value={option.product_variant_cd}>{option.size + ' ' + option.product_unit.toLowerCase()}</option>
                            )
                        })}
                    </select>
                </div>
                <div className={classes.Info_cta}>
                    <ContactUs buttonTitle={<FormattedMessage id={"proddetail.contactus"} defaultMessage={"Contact Our Sales"}/>}
                               productCategorySelected={null}
                               customPosition={'fixed'}
                               paramMessage={product.product_category_name
                               + ", " + product.product_brand_name
                               + ", " + product.name
                               + messageSize}/>
                </div>
            </div>
        );
    }

    let lProductInfo = (
        <ProductInfo data_certificate={state.product_certificates} data={state.product}/>
    );


    let totalRelated = 0;
    if (state.related_menu_ideas.length > 0) {
        totalRelated = state.related_menu_ideas.length;
    }

    const toggleTab = (id) => {
        setSwitchTab(id)
        if (id === 2) {
            setInitEffect(true)
        } else {
            dispatch({type: 'LOAD_MENU_IDEAS', payload: false})
            setInitEffect(null)
        }
    }

    return (
        <>
            <Helmet>
                <meta name="description" content={metaDesc}/>
                <meta name="keywords" content={"frozen food, meat shop, Chicken shop, supplier frozen food, food service, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, food solutions, JBFS, Food Supplier"}/>
                <meta name="author" content=""/>
                <meta property="og:title"
                      content={state.product.name !== undefined ?
                          `${state.product.name}${(" | Japfa Food | Indonesia | Food Supplier")}`
                          : 'Product Detail | Japfa Food | Indonesia | Food Supplier'}/>
                <meta property="og:description" content={"JAPFA FOOD: " + metaDesc}/>
                <title>{
                    localStorage.getItem('selected_product_name') &&
                        `${localStorage.getItem('selected_product_name')}${(" | Japfa Food | Indonesia | Food Supplier")}`
                }</title>
                <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
            </Helmet>

            <section className={classes.ProductDetail_section}>
                <div className={["jbfs-wrapper", classes.ProductDetailPage_wrapper].join(' ')}>

                    {state.isLoading ? (<LoadingSimple position={'left'}/>) : breads}

                    <div className={classes.Detail_sections}>
                        <section className={classes.ProdDetailBody_section}>
                            <div className={classes.Body_wrapper}>
                                <div className={classes.MainImage_column}>
                                    {stringBadge}
                                    <div className={classes.MainImage_bgImage} style={{backgroundImage: `url(${state.main_image})`}}/>
                                </div>
                                <div className={classes.Thumbnail_column}>
                                    {thumbnails}
                                </div>
                                <div className={classes.ProductInfo_column}>
                                    <div className={classes.ProductInfo_wrapper}>
                                        {productInfo}
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className={classes.Footer_section}>
                            <div className={classes.Footer_wrapper}>

                                <div className={classes.Tab_header}>
                                    <ul className={classes.Tab_headerWrapper}>
                                        <li onClick={() => toggleTab(1)} className={switchTab === 1 ? classes.Tab_headerActive : classes.Tab_headerInactive}>
                                            <div><FormattedMessage id={"proddetail.productinfo"} defaultMessage={"Product Info"}/></div>
                                        </li>
                                        <li onClick={() => toggleTab(2)} className={switchTab === 2 ? classes.Tab_headerActive : classes.Tab_headerInactive}>
                                            <div>{state.related_menu_ideas.length > 0 ? <span className={classes.Total_info}>{totalRelated}</span> : ''}<FormattedMessage id={"proddetail.relatedmenu"} defaultMessage={"Related Menu Ideas"}/></div>
                                        </li>
                                    </ul>
                                </div>
                                <div className={classes.Tab_content}>
                                    <div className={classes.Tab_contentWrapper}>
                                        <div>
                                            {switchTab === 1 ?
                                                <div>
                                                    {lProductInfo}
                                                </div>
                                                :
                                                <div className={classes.RelatedInfo_container}>
                                                    <RelatedInfo home_menu_ideas={state.related_menu_ideas}/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProductDetailPageHook